var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"","id":"app"}},[_c('b-row',{staticStyle:{"text-align":"center"}},[_c('b-col',[_c('h1',[_vm._v("404 - PAGE NOT FOUND")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }